const SNOWPLOW_STORAGE_KEY = 'snowplowOutQueue_gladly_snowplow_cf_post2';
const MAX_STORAGE_SIZE = 10000;

export default function clearExcessSnowplowStorage(storage) {
  if (!!storage[SNOWPLOW_STORAGE_KEY] && storage[SNOWPLOW_STORAGE_KEY].length > MAX_STORAGE_SIZE) {
    localStorage.removeItem(SNOWPLOW_STORAGE_KEY);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/adapters/stores/lib/clear_excess_snowplow_storage.js